export class ActorManualTriggersController {
  constructor(actorsManager) {
    this.actorsManager = actorsManager;
    this._scene = actorsManager.scene;
  }
  runTriggers() {
    if (!this._triggered()) {
      return;
    }
    const triggeredNodeParent = this._triggeredNodeParent();
    if (!triggeredNodeParent) {
      return;
    }
    const nodeToRunTriggerFrom = this._nodeToRunTriggerFrom;
    const nodeToReceiveTrigger = this._nodeToReceiveTrigger;
    this._reset();
    const nodeParentId = triggeredNodeParent.graphNodeId();
    this._scene.threejsScene().traverse((object) => {
      const nodeIds = this.actorsManager.objectActorNodeIds(object);
      if (!nodeIds) {
        return;
      }
      if (!nodeIds.includes(nodeParentId)) {
        return;
      }
      if (nodeToRunTriggerFrom) {
        nodeToRunTriggerFrom.runTrigger({ Object3D: object });
      }
      if (nodeToReceiveTrigger) {
        nodeToReceiveTrigger.receiveTrigger({ Object3D: object });
      }
    });
  }
  setNodeToRunTriggerFrom(node) {
    this._nodeToRunTriggerFrom = node;
  }
  setNodeToReceiveTrigger(node) {
    this._nodeToReceiveTrigger = node;
  }
  _triggered() {
    return this._nodeToRunTriggerFrom != null || this._nodeToReceiveTrigger != null;
  }
  _triggeredNodeParent() {
    const node = this._nodeToRunTriggerFrom || this._nodeToReceiveTrigger;
    if (!node) {
      return;
    }
    return this.actorsManager.parentActorBuilderNode(node);
  }
  _reset() {
    this._nodeToRunTriggerFrom = void 0;
    this._nodeToReceiveTrigger = void 0;
  }
}
